document.addEventListener('DOMContentLoaded', function () {
  const expireDays = 365; // 有効期限（日）
  const cc = document.querySelector('.cookie');
  const ca = document.querySelector('.cookie-agree');
  const flag = localStorage.getItem('popupFlag');

  function showPopup() {
    cc.classList.add('is-show');
  }

  function setWithExpiry(key, value, days) {
    const expireTime = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem(key, JSON.stringify({ value, expire: expireTime }));
  }

  if (flag) {
    const data = JSON.parse(flag);
    const now = Date.now();

    if (data.value === 'true') {
      showPopup();
    } else if (now > data.expire) {
      setWithExpiry('popupFlag', 'true', expireDays);
      showPopup();
    }
  } else {
    setWithExpiry('popupFlag', 'true', expireDays);
    showPopup();
  }

  ca.addEventListener('click', function () {
    cc.classList.add('cc-hide2');
    setWithExpiry('popupFlag', 'false', expireDays);
  });
});
